/**
 * Theme configuration for styled-components
 * Centralizes all color choices and design tokens
 */

export const theme = {
    colors: {
        primary: '#E8B84D',      // Golden caramel with less yellow hue - main brand color
        primaryDark: '#D4A520',  // Darker golden for hover states
        secondary: '#3F4247',    // Gray secondary color
        background: '#FFFFFF',   // White
        backgroundDark: '#1F1612', // Space gray background (default)
        backgroundDarker: '#1F1612', // Dark chocolate brown for alternating sections
        backgroundLighter: '#2A1F18', // Slightly lighter brown for alternating sections
        text: '#FFFFFF',         // White text
        textDark: '#1A1C1F',     // Dark gray text for light backgrounds
        textMuted: '#9CA3AF',    // Muted gray text
        accent: '#E8A547',       // Golden accent with less yellow
        divider: '#3F4247',      // Gray divider lines
    },
    spacing: {
        xs: '0.5rem',
        sm: '1rem',
        md: '1.5rem',
        lg: '2rem',
        xl: '3rem',
        xxl: '4rem',
        section: '5rem',
    },
    fonts: {
        primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
        heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
    },
    fontSizes: {
        title: '0.875rem',       // Small uppercase titles
        paragraph: '1.25rem',    // Body text - increased from 1.125rem
        header: '3rem',          // Large headers (desktop)
        headerMobile: '2rem',    // Large headers (mobile)
        button: '1rem',
        small: '0.875rem',       // Small button text
        medium: '1rem',          // Medium button text
        large: '1.125rem',       // Large button text
    },
    fontWeights: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    borderRadius: {
        small: '4px',
        medium: '8px',
        large: '12px',
        button: '6px',
    },
    breakpoints: {
        mobile: '768px',
        tablet: '1024px',
        desktop: '1440px',
    },
};

// Type definition for the theme to ensure type safety
export type Theme = typeof theme;
